import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "./api_helper";

export const makeThunk = (config) => {
  let { type, url, method = "post" } = config || {};

  if (!type) type = typeof url === "string" ? url : undefined;

  return createAsyncThunk(type, async (payload, thunkAPI) => {
    try {
      const finalUrl = typeof url === "function" ? url(payload) : url;

      const response =
        method === "get"
          ? await api.get(finalUrl)
          : await api[method](finalUrl, payload);
          console.log(response)
      if (method === "download") {
        return Array.from(new Uint8Array(response));
      } else {
        return response;
      }
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  });
};

// export const makeThunk = (config) => {

//   let { type, url, method = "post" } = config || {};

//   if (!type) type = url;

//   return createAsyncThunk(type, async (payload, thunkAPI) => {
//     try {
//       const response = await api[method](url, payload);
//       return response;
//     } catch (err) {
//       return thunkAPI.rejectWithValue(
//         err?.response?.data?.message || "Something went wrong"
//       );
//     }
//   });
// };
